import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus } from "lucide-react";
interface UploadButtonProps {
  isUploading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const UploadButton = ({
  isUploading,
  onChange
}: UploadButtonProps) => {
  return <div className="relative">
      <Input type="file" accept="image/*" onChange={onChange} className="hidden" id="image-upload" disabled={isUploading} multiple />
      <Label htmlFor="image-upload" className="flex flex-col items-center justify-center w-full aspect-square border-2 border-dashed rounded-lg cursor-pointer hover:border-primary">
        {isUploading ? <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
            <span className="mt-2 text-sm text-gray-500">Uploading...</span>
          </div> : <>
            <Plus className="w-8 h-8 text-gray-400" />
            
          </>}
      </Label>
    </div>;
};
